export default "/assets/site/images/asztalitenisz.jpg?d9c879bfd9dd60ba70169447dadef314";